export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
